import React from 'react';

const About: React.FC = () => {
  return (
    <div className="container py-16 max-w-4xl">
      <div className="text-center mb-16">
        <h1 className="text-5xl font-bold text-neutral-900 mb-6">About Demo Crackers</h1>
        <p className="text-xl text-gray-600 leading-relaxed">
          Your trusted partner for premium quality firecrackers and celebrations since 2010
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-16">
        <div>
          <h2 className="text-3xl font-bold text-neutral-900 mb-6">Our Story</h2>
          <p className="text-lg text-gray-700 leading-relaxed mb-4">
            Demo Crackers was founded with a simple mission: to bring joy and excitement to every celebration 
            while maintaining the highest standards of safety and quality.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed mb-4">
            What started as a small family business has grown into one of India's most trusted names 
            in fireworks, serving over 500 happy customers across the country.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            We believe that every celebration deserves spectacular fireworks, and we're committed 
            to making that happen safely and responsibly.
          </p>
        </div>
        <div className="bg-gradient-to-br from-accent-600 to-accent-500 rounded-2xl p-8 text-center">
          <div className="text-6xl mb-4">🎆</div>
          <h3 className="text-2xl font-bold text-white mb-4">Lighting Up Lives</h3>
          <p className="text-accent-100">Since 2010</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
        <div className="text-center">
          <div className="text-4xl mb-4">🏆</div>
          <h3 className="text-xl font-bold text-neutral-900 mb-2">Premium Quality</h3>
          <p className="text-gray-600">All our products are certified and tested for safety and performance</p>
        </div>
        <div className="text-center">
          <div className="text-4xl mb-4">🔒</div>
          <h3 className="text-xl font-bold text-neutral-900 mb-2">Safety First</h3>
          <p className="text-gray-600">We prioritize safety in every product we sell and every service we provide</p>
        </div>
        <div className="text-center">
          <div className="text-4xl mb-4">🚚</div>
          <h3 className="text-xl font-bold text-neutral-900 mb-2">Fast Delivery</h3>
          <p className="text-gray-600">Quick and secure delivery to your doorstep across India</p>
        </div>
      </div>

      <div className="bg-cream-100 rounded-2xl p-8 text-center">
        <h2 className="text-3xl font-bold text-neutral-900 mb-4">Our Commitment</h2>
        <p className="text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto">
          At Demo Crackers, we're committed to providing you with the finest selection of fireworks while 
          ensuring complete safety and customer satisfaction. Our team of experts carefully curates 
          every product to meet the highest standards of quality and safety.
        </p>
      </div>
    </div>
  );
};

export default About;